import { useState, useMemo } from 'react';
import SEO from '../../components/SEO';
import AdUnit from '../../components/AdUnit';

function RoiCalculator() {
  const [investment, setInvestment] = useState(10000);
  const [revenue, setRevenue] = useState(15000);
  const [period, setPeriod] = useState('one-time');

  var result = useMemo(function () {
    var profit = revenue - investment;
    var roi = investment > 0 ? (profit / investment) * 100 : 0;
    var annualRoi = period === 'monthly' ? roi * 12 : period === 'quarterly' ? roi * 4 : roi;
    return { profit: profit, roi: roi, annualRoi: annualRoi };
  }, [investment, revenue, period]);

  var fmt = function (n) { return '₹' + Math.round(n).toLocaleString('en-IN'); };

  return (
    <div className="page-prettifier">
      <SEO title="ROI Calculator - Calculate Return on Investment" description="Free online ROI calculator. Calculate return on investment, profit, and annualized ROI for any business investment or marketing campaign." path="/roi-calculator" />
      <div className="container">
        <div className="tool-header">
          <h1>ROI Calculator</h1>
          <p>Calculate the return on investment for any business decision, marketing campaign, or financial investment.</p>
        </div>
        <AdUnit />
        <div className="calc-layout">
          <div className="calc-inputs">
            <div className="form-group">
              <label htmlFor="roi-investment">Total Investment (₹)</label>
              <input id="roi-investment" type="number" min="0" value={investment} onChange={function (e) { setInvestment(parseFloat(e.target.value) || 0); }} className="color-input" />
            </div>
            <div className="form-group">
              <label htmlFor="roi-revenue">Total Revenue / Return (₹)</label>
              <input id="roi-revenue" type="number" min="0" value={revenue} onChange={function (e) { setRevenue(parseFloat(e.target.value) || 0); }} className="color-input" />
            </div>
            <div className="form-group">
              <label htmlFor="roi-period">Time Period</label>
              <select id="roi-period" value={period} onChange={function (e) { setPeriod(e.target.value); }} className="indent-select" style={{ width: '100%' }}>
                <option value="one-time">One-time</option>
                <option value="monthly">Monthly</option>
                <option value="quarterly">Quarterly</option>
              </select>
            </div>
          </div>
          <div className="calc-results">
            <div className="stats-grid" style={{ width: '100%' }}>
              <div className="stat-card"><div className={"stat-number" + (result.profit >= 0 ? '' : ' negative')}>{fmt(result.profit)}</div><div className="stat-label">Net Profit</div></div>
              <div className="stat-card"><div className={"stat-number" + (result.roi >= 0 ? '' : ' negative')}>{result.roi.toFixed(1)}%</div><div className="stat-label">ROI</div></div>
              {period !== 'one-time' && <div className="stat-card"><div className="stat-number">{result.annualRoi.toFixed(1)}%</div><div className="stat-label">Annualized ROI</div></div>}
            </div>
          </div>
        </div>
        <section className="tool-guide">
          <h2>What is ROI?</h2>
          <p>Return on Investment (ROI) measures how much profit or loss you made relative to your initial investment. It is expressed as a percentage. An ROI of 50% means you earned half of your investment back as profit. Businesses use ROI to evaluate marketing campaigns, hiring decisions, equipment purchases, and more.</p>
          <h2>How to Improve Your ROI</h2>
          <ul>
            <li>Track all costs accurately, including hidden expenses like time and opportunity cost.</li>
            <li>Focus on high-converting channels and cut underperforming ones.</li>
            <li>A/B test marketing campaigns to optimize spend before scaling.</li>
            <li>Negotiate better rates with vendors and suppliers.</li>
            <li>Invest in customer retention — it costs less than acquiring new customers.</li>
          </ul>
        </section>
      </div>
    </div>
  );
}

export default RoiCalculator;
